import useBreadcrumb from "../../Hooks/useBreadcrumb"
import Reveal from "../LandingPage/shared/Reveal"
import styles from "./BlogPage.module.css"

export default function BlogPage() {
    const BreadCrumb = useBreadcrumb('Blog');
    return <div className={styles.page}>

            {BreadCrumb}

            <section className={styles.hero}>
                <div className={styles.wrap}>
                    <Reveal>
                        <p className={styles.eyebrow}>Blog</p>
                        <h1 className={styles.heading}>From the pool deck</h1>
                        <p className={styles.lede}>
                            Technique notes, training advice and meet-day guidance from our coaches.
                        </p>
                        <p className={styles.soon}>New articles are on the way.</p>
                    </Reveal>
                </div>
            </section>

        </div>
}
